export default __webpack_public_path__ + "static/media/seminar (3).c1518c97.JPG";